import axios from "axios";
const baseUrl = `${process.env.REACT_APP_AUTOREPAIR_API}/api`;

/*  export const getAllProjects = () => {
    return axios.get(`${baseUrl}/projects`);
};

export const getProject = (id) => {
    return axios.get(`${baseUrl}/projects/${id}`);
};

export const deleteProject = (id) => {
    return axios.delete(`${baseUrl}/projects/${id}`);
};

export const addProject = (project) => {
    return axios.post(`${baseUrl}/projects`, project);
} */




/**/



export const deleteReviews = (id) => {
    return axios.delete(`${baseUrl}/reviews/${id}`);
};

/* Retrieve Appointments */
export const getAllReviews = () => {
    return axios.get(`${baseUrl}/reviews`, {withCredentials: true});
};

export const addReview = (review) => {
    return axios.post(`${baseUrl}/reviews`, review, {withCredentials: true});
};



/**/



/* Delete Appointments */
export const deleteAppointments = (id) => {
    return axios.delete(`${baseUrl}/appointments/${id}`);
};

/* Retrieve Appointments */
export const getAllAppointments = () => {
    return axios.get(`${baseUrl}/appointments`, {withCredentials: true});
};

/* Book Appointment */
export const bookAppointment = (appointment) => {
    return axios.post(`${baseUrl}/appointments`, appointment, {withCredentials: true});
};



/**/



/* Delete From Favourites */
export const deleteFavourites = (id) => {
    return axios.delete(`${baseUrl}/favourites/${id}`);
};


/* Retrieve Car Repair Info */
export const getAllFavourites = () => {
    return axios.get(`${baseUrl}/favourites`, {withCredentials: true});
};

/* Upload Car Repair Info - Add to Favourites */
export const favourites = ( name, rating, icon ) => {
    return axios.post(`${baseUrl}/favourites`, { name, rating, icon }, {withCredentials: true});
}



/**/



/* Upload Cloudinary Imges */
export const uploadFile = (uploadData) => {
    return axios.post(`${baseUrl}/upload`, uploadData);
} 



/**/



/* Update Current User */
export const updateUser = (updatedUser) => {
    return axios.put(`${baseUrl}/users/${updatedUser._id}`, updatedUser);
  } 

  /* Authentication Routes */
export const signup = ( username, email, password ) => {
    return axios.post(`${baseUrl}/signup`, { username, email, password });
}

export const login = ( username, password ) => {
    return axios.post(`${baseUrl}/login`, { username, password }, {withCredentials: true});
}

export const logout = () => {
        return axios.post(`${baseUrl}/logout`, null, {withCredentials: true});
      }
      
export const loggedIn = () => {
        return axios.get(`${baseUrl}/loggedin`, {withCredentials: true});
      }